import React from 'react'

export const Footer = () => {
    return (
        <>
            <section className="footer_main">
                <article className="footer_content">
                    <h1>¡Un leasing habitacional <span>como ningún otro!</span> </h1>
                    <button className="footer_btn widget">
                        ¡Solicítalo ya!
                    </button>
                </article>
            </section>
            <footer className="footer">
                <img src="./assets/img/colaraicesbl.png" alt="Compra casa en colombia desde elexterior" />
            </footer>
        </>
    )
}
